import React, { createContext, useState } from 'react';
import { INewWebFormStore } from './interfaces/INewWebFormStore';

/* eslint-disable @typescript-eslint/ban-types, @typescript-eslint/no-empty-function */

const initalState = {
  changeValue: false,
  setChangeValue: () => { },
  ForceUpdate: () => { },
};


export const NewWebFormContext = createContext<INewWebFormStore>(initalState);
export default function NewWebFormProvider({ children }: { children: React.ReactNode }) {
  const [changeValue, setChangeValue] = useState(false);

  function ForceUpdate() {
    setChangeValue(!changeValue);
  }

  const store = {
    changeValue,
    setChangeValue,
    ForceUpdate,
  };

  return (
    <NewWebFormContext.Provider value={store}>
      {children}
    </NewWebFormContext.Provider>
  );
}